import React, { memo } from "react";
import { useI18n } from "./integrations/formatjs/I18nContext";
import { shallowEqual } from "./utils/shallowEqual";
const I18nNumber = ({ domain, value, style, currency, unit, unitDisplay, }) => {
    const intl = useI18n({ domain });
    return (React.createElement(React.Fragment, null, intl.formatNumber(value, { style, currency, unit, unitDisplay })));
};
const MemoizedI18nNumber = memo(I18nNumber, shallowEqual);
export { MemoizedI18nNumber as I18nNumber };
